import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import PrivateRoute from './common/components/private-route/private-route.component';
import routes from './routes';
import Dashboard from './messages/dashboard/dashboard.component';
import FileDetails from './messages/dashboard/file-details/file-details.component';
import Header from './common/components/header/header.component';
import Spinner from './common/components/spinner/spinner.component';
import Notifications from './common/components/notifications/notifications.component';
import ConfirmationPopup from './common/components/confirmation-popup/confirmation-popup.component';
import Recorder from './messages/recorder/recorder.component';
import Help from './messages/help/help.component';
import Authentication from './messages/authentication/authentication.component';
import './message-banking.css';

const MessageBanking = () => (
  <div className="message-banking">
    <Spinner />
    <Header />
    <Notifications />
    <ConfirmationPopup />
    <Switch>
      <Route path={routes.authentication} component={Authentication} />
      <PrivateRoute exact path={routes.dashboard} component={Dashboard} />
      <PrivateRoute path={routes.files_list} component={Dashboard} />
      <PrivateRoute path={routes.file_details} component={FileDetails} />
      <PrivateRoute path={routes.help} component={Help} />
      <PrivateRoute path={routes.recorder} component={Recorder} />
      <Route render={() => <Redirect to={routes.dashboard} />} />
    </Switch>
  </div>
);

export default MessageBanking;



// WEBPACK FOOTER //
// ./src/message-banking.js